import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';

import Config from './Config';
import Router from './Routing';

import Header from './modules/header'
import Sidebar from './modules/sidebar'

import { apiRequest } from './utils/api'

import './resources/App.css';

class App extends Component {
  constructor(){
    super();
    this.state = {
      view: Router.VIEWSTATE_LOADING,
      viewstate: null,
      params: null,
      args: null,
      pageView: null,
      user: null,
      organisation: null,
      alert: null,
    };
  }

  async componentDidMount(){
    this.init();
  }

  async fetchMe(){
    try{

      const user = await apiRequest({
        method: "GET",
        url: "auth/me"
      })

      this.setState({
        user
      })

      return true
    }catch(ex){
      console.log(ex)
      return false
    }
  }

  setHeaderTitle(title){
    this.setState({
      headerTitle: title
    })
  }

  /*
   *  We push the new page to history and init again.
   *  This way we don't refresh the page and preserve the current state.
   */
  navigate(data){
    const { name, path, windowTitle } = data
    window.history.pushState(name, windowTitle, `${Config.homepage}/${path}`);
    this.init();
  }

  async init(){
    const path = window.location.pathname.replace(Config.homefolder, "")
    const args = (path.startsWith("/")) ? path.substring(1).split("/") : path.split("/")
    const page = args[0].toLowerCase()

    /**
     *  Fetch the viewstate from router object
     */
    let pageView = Router.viewstates.find((state) => {
      return state.path === page
    })

    /**
     *  If router object contains requireLogin check user session.
     */
    if(!pageView || pageView.requireLogin){
      if(!this.state.user && !await this.fetchMe()){
        //Need to login!
        pageView = Router.viewstates.find((state) => {
          return state.path === "login"
        })
      }
      if(!this.state.user){
        //Need to login!
        pageView = Router.viewstates.find((state) => {
          return state.path === "login"
        })
      }
    }

    const viewState = ((pageView === undefined)?
        Router.VIEWSTATE_FORM : pageView.viewstate
    );

    const view = ((pageView === undefined)?
        Router.VIEWSTATE_NOTFOUND : pageView.view
    );

    this.setState({
      args,
      viewState,
      view,
      pageView,
      params: null
    })
  }

  setViewState(viewState, params){
    let _viewState = Router.viewstates.find((obj) => {
      return obj.viewstate === viewState
    })
  	if(_viewState === undefined){
      return this.setState({
        params,
        viewState: undefined,
        view: undefined
      })
    }
    this.setState({
      params,
      viewState,
      view: _viewState.view
    })
  }

  getAlert(alert){
    if(!alert){
      return
    }
    return (
      <div className="App-Alert" onClick={() => this.setState({ alert: null })}>
        <Alert variant={alert.type} onClose={() => this.setState({ alert: null })} dismissible>
            {alert.message}
        </Alert>
      </div>
    )
  }

  setAlert(alert, timeout){
    if(alert !== null && (alert.type === undefined || alert.message === undefined)){
      return console.log("Trying to set invalid alert.")
    }
    clearTimeout(this.alertTimeout)
    this.setState({
      alert
    })
    if(timeout !== undefined){
      this.alertTimeout = setTimeout(() => {this.setAlert(null)}, timeout)
    }
  }

  getView(){
    try {
      const View = this.state.view

      return (!View)? <Router.VIEWSTATE_NOTFOUND /> : <View
        organisation={this.state.organisation}
        user={this.state.user}
        init={() => this.init()}
        params={this.state.params}
        args={this.state.args}
        setViewState={(viewState, params) => this.setViewState(viewState, params)}
        navigate={(data) => this.navigate(data)}
        setHeaderTitle={(title) => this.setHeaderTitle(title)}
        setAlert={(alert, timeout) => this.setAlert(alert, timeout)}
      />
    }catch(ex){
      console.log(JSON.stringify(ex));
      return <Router.VIEWSTATE_ERROR params={ex} />
    }
  }

  render(){
    const { viewState, headerTitle, pageView } = this.state
    return (
      <div className="App">
        {this.getAlert(this.state.alert)}
        {(pageView && pageView.header)?
          <Header user={this.state.user} organisation={this.state.organisation} title={Config.title} />
          :
          ""
        }
        {(pageView && pageView.sidebar)?
          <Sidebar user={this.state.user} organisation={this.state.organisation} viewState={viewState} init={() => this.init()} />
          :
          ""
        }
        <div className="content" style={(pageView && pageView.header)? {marginTop: "50px"} : {}}>
          {this.getView()}
        </div>
      </div>
    );
  }
}

export default App;
